
export default {
    name: 'OpinionTable',
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            },
        },
        isChartOpened: {
            type: Boolean,
            required: true,
        },
        openChart: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            renderLength: 5,
            isMore: false,
            loadingStatus : false,
        }
    },
    computed: {
        filteredItems() {
            const slice =
                this.data &&
                this.data.slice(
                    0,
                    this.renderLength ? this.renderLength : this.data.length
                )

            return slice
        },
    },
    methods: {
        moreButton() {
            this.isMore = true
            this.renderLength = 0
        },
        hideButton() {
            this.isMore = false
            this.renderLength = 5
        },
        triggerOpenChart() {
            if (!this.isChartOpened) {
                this.openChart()
            }
        },
    },
}
